'use client';

import React from 'react';
import { newCarsProject, newCarsTrack } from '~/constants/eventable';
import AnalyticsProvider from '~/context/common/AnalyticsProvider';
import {
  DeviceContextProvider,
  type OwnProps as DeviceContextProps
} from '~/context/common/DeviceContext';
import {
  StaticContextProvider,
  type OwnProps as StaticContextProps
} from '~/context/common/StaticContext';
import {
  UserContextProvider,
  type OwnProps as UserContextProps
} from '~/context/common/UserContext';
import { ModalContextProvider } from '~/context/new-cars/ModalContext';

type OwnProps = React.PropsWithChildren<{
  forDeviceContext: DeviceContextProps;
  forStaticContext: StaticContextProps;
  forUserContext: UserContextProps;
}>;

export default function NewCarsLandingProviders({
  children,
  forDeviceContext,
  forStaticContext,
  forUserContext
}: OwnProps) {
  return (
    <StaticContextProvider {...forStaticContext}>
      <DeviceContextProvider {...forDeviceContext}>
        <UserContextProvider {...forUserContext}>
          <AnalyticsProvider projectName={newCarsProject} track={newCarsTrack}>
            <ModalContextProvider>{children}</ModalContextProvider>
          </AnalyticsProvider>
        </UserContextProvider>
      </DeviceContextProvider>
    </StaticContextProvider>
  );
}
